// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3WFOL","search":"Settings_search__1CxJg","filter":"Settings_filter__1CXkP"};